// extracted by mini-css-extract-plugin
module.exports = {"container":"detail-page-container_container__3KAoN"};